(function () {
  'use strict';
  if (customElements.get('pg-help')) return;
  class PgHelp extends HTMLElement {
    connectedCallback() {
      if (this.controller || !('showPopover' in HTMLElement.prototype)) return;
      this.controller = new AbortController();
      this.button = this.querySelector('.pg-help__trigger');
      this.panel = this.querySelector('.pg-help__panel');
      this.panel.addEventListener('toggle', (event) => {
        this.positionController?.abort();
        if (event.newState !== 'open') return;
        this.position();
        this.positionController = new AbortController();
        var options = { signal: this.positionController.signal, passive: true };
        window.addEventListener('resize', () => this.position(), options);
        window.addEventListener('scroll', () => this.position(), { ...options, capture: true });
      }, { signal: this.controller.signal });
    }
    position() {
      var anchor = this.button.getBoundingClientRect(), panel = this.panel.getBoundingClientRect();
      var width = document.documentElement.clientWidth, height = window.innerHeight;
      if (anchor.bottom < 0 || anchor.top > height) { this.panel.hidePopover(); return; }
      var left = Math.max(12, Math.min(anchor.left, width - panel.width - 12));
      var top = anchor.bottom + 8;
      if (top + panel.height > height - 12) top = anchor.top - panel.height - 8;
      top = Math.max(12, Math.min(top, height - panel.height - 12));
      this.panel.style.setProperty('--pg-help-left', left + 'px');
      this.panel.style.setProperty('--pg-help-top', top + 'px');
    }
    disconnectedCallback() { this.controller?.abort(); this.positionController?.abort(); this.controller = null; }
  }
  customElements.define('pg-help', PgHelp);
}());
